import { DialogTrainingState } from "../Enums/DialogTrainingState";
import {
    OPEN_DIGITAL_SHARE_DIALOGUE_FROM_WRAPPER,
    SET_DIGITAL_SHARE_DIALOG_TRAINING_STATE,
} from "./Types";
import {IPdfHtmlData} from "../Common/Models";
import {Action} from "redux";

export const GET_PDF_LAMBDA = 'SAGAS/GET_PDF_LAMBDA';


export const setDialogTrainingState = (data: DialogTrainingState) => {
    return {
        type: SET_DIGITAL_SHARE_DIALOG_TRAINING_STATE,
        data: data,
    };
};

export const openDigitalShareDialogue = (open: boolean) => ({
    type: OPEN_DIGITAL_SHARE_DIALOGUE_FROM_WRAPPER,
    data: open,
});

export const getPdfLambdaAction = (
    data: IPdfHtmlData[] | string,
) => ({
    type: GET_PDF_LAMBDA,
    data,
});

